import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex } from '../../units/Box/Box';
import Text from '../../units/Text/Text';

import { InputElement, InputMaskElement } from './InputUnits';
import withValidation from '../../hocs/withValidation';

const InputWrapper = styled(Flex)`
  position: relative;
`;

const LabelContainer = styled(Box).attrs({
  mr: '20px'
})`
  width: ${props => props.width};
  text-align: right;
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
`;

const Label = styled(Text).attrs({
  font: 'caption',
  size: '13px',
  color: '#555555'
})``;

class Input extends Component {
  renderLabel = () => {
    const { label, labelParams: {width, spacing, whiteSpace} } = this.props;

    return (
      label && (
        <LabelContainer width={width}>
          <Label spacing={spacing} whiteSpace={whiteSpace}>{label}</Label>
        </LabelContainer>
      )
    );
  };

  render() {
    const {
      name,
      value,
      onChange,
      onFocus,
      onBlur,
      onKeyDown,
      placeholder,
      disabled,
      maxLength,
      readOnly,
      inputType,
      id,
      mask,
      showMask,
      guide,
      hasError,
      width,
      height,
      letterSpacing,
      font,
      fontSize,
      autoFocus
    } = this.props;

    const inputComponentProps = {
      value,
      disabled,
      placeholder,
      onChange,
      onFocus,
      onBlur,
      onKeyDown,
      maxLength,
      readOnly,
      id,
      type: inputType,
      haserror: hasError.toString(),
      width,
      height,
      letterSpacing,
      fontSize,
      font,
      showMask,
      autoFocus,
      keepCharPositions: true,
      ...(mask ? { mask, guide } : {})
    };

    const InputComponent = mask ? InputMaskElement : InputElement;

    return (
      <InputWrapper align="center">
        {this.renderLabel()}
        <InputComponent className={`input-${name}`} {...inputComponentProps} />
      </InputWrapper>
    );
  }
}

Input.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  readOnly: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  letterSpacing: PropTypes.string,
  fontSize: PropTypes.string,
  disabled: PropTypes.bool,
  inputType: PropTypes.string,
  fieldType: PropTypes.string,
  label: PropTypes.string,
  labelParams: PropTypes.object,
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  guide: PropTypes.bool,
  type: PropTypes.oneOf(['bordered']),
  font: PropTypes.oneOf(['regular', 'caption']),
  hasError: PropTypes.bool,
  showMask: PropTypes.bool,
  autoFocus: PropTypes.bool
};

Input.defaultProps = {
  name: '',
  id: '',
  onFocus: null,
  onBlur: null,
  onKeyDown: null,
  value: '',
  placeholder: '',
  maxLength: null,
  readOnly: false,
  width: '100%',
  height: '40px',
  fontSize: '18px',
  letterSpacing: 'initial',
  disabled: false,
  inputType: 'text',
  fieldType: null,
  label: '',
  labelParams: {
    spacing: 'initial'
  },
  mask: null,
  guide: false,
  type: 'bordered',
  font: 'regular',
  hasError: false,
  showMask: false,
  autoFocus: false
};

export default withValidation(Input);



// WEBPACK FOOTER //
// ./src/components/units/Input/Input.js